import { useState } from 'react'
import { useAuth } from '../layout/AuthContext'
import PasswordInput from '../components/PasswordInput'
import { checkForm } from '../forms/checkForm'
import { PAGES_LOGIN_TEXTS as T } from '../../shared/texts'

export default function Login() {
    const { login } = useAuth()
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [error, setError] = useState('')
    const [busy, setBusy] = useState(false)

    async function onSubmit(e: React.FormEvent) {
        e.preventDefault()
        if (!checkForm(e.currentTarget as HTMLFormElement).ok) return
        setBusy(true); setError('')
        try {
            await login(email, password)
        } catch (err: any) {
            setError(err?.response?.data?.error ?? T.loginFailed)
        } finally {
            setBusy(false)
        }
    }

    return (
        <div className="login-page">
            <form className="login-card" noValidate onSubmit={onSubmit}>
                <img src="/logo-deja.png" alt={T.logoAlt} className="login-logo" />
                <h1>{T.title}</h1>
                {error && <div className="notice err">{error}</div>}
                <div className="field">
                    <label htmlFor="login-email">{T.email}</label>
                    <input id="login-email" type="email" autoComplete="username" autoFocus
                        value={email} onChange={(e) => setEmail(e.target.value)} required />
                </div>
                <div className="field">
                    <label htmlFor="login-password">{T.password}</label>
                    <PasswordInput id="login-password" autoComplete="current-password"
                        value={password} onChange={setPassword} required />
                </div>
                <button type="submit" disabled={busy}>{busy ? '…' : T.submit}</button>
            </form>
        </div>
    )
}
